module.exports = __webpack_public_path__ + "img/21.e098499a.png";